import { useEffect, useState } from "react";
import ExploreChatButton from "./ExploreChatButton";
import {
  loadSalesIQScript,
  registerSalesIQListeners,
  unloadSalesIQScript,
} from "./salesIQUtils";
import "./exploreSalesIQ.css";

export default function ZohoSalesIQ() {
  const [chatOpen, setChatOpen] = useState(false);

  useEffect(() => {
    document.body.classList.add("explore-chat-active");

    loadSalesIQScript({
      onOpen: () => setChatOpen(true),
      onClose: () => setChatOpen(false),
    });

    return () => {
      document.body.classList.remove("explore-chat-active", "explore-chat-open");
      unloadSalesIQScript();
    };
  }, []);

  useEffect(() => {
    registerSalesIQListeners({
      onOpen: () => setChatOpen(true),
      onClose: () => setChatOpen(false),
    });
  }, []);

  return !chatOpen ? <ExploreChatButton /> : null;
}
